import { render, staticRenderFns } from "./rightPageYb.vue?vue&type=template&id=47f4b3f6&scoped=true&"
import script from "./rightPageYb.vue?vue&type=script&lang=js&"
export * from "./rightPageYb.vue?vue&type=script&lang=js&"
import style0 from "./rightPageYb.vue?vue&type=style&index=0&id=47f4b3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4b3f6",
  null
  
)

export default component.exports